import VideoPlayer from "@/components/VideoPlayer"
import { urlForImage } from "@/sanity/lib/image"
import Image from "next/image"
import Link from "next/link"

export default function RelatedProjectsGrid({relatedProjects}) {
	return (
		<div className="site-wrapper px-site-margin mt-[6rem] sm:mt-[8rem] md:mt-[10rem]">
			<h2 className="style-h3 mb-12">Related Projects</h2>
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-gutter [@media(max-width:711px)]:[&>*:nth-child(n+2)]:hidden [@media(max-width:1111px)]:[&>*:nth-child(n+3)]:hidden">
				{relatedProjects?.map((project, index) => (
					<Link key={`item-${project?.title}`} href={`/work/${project?.slug?.current}`} className="relative">
						<div className="relative w-full rounded-weak overflow-clip aspect-video">
							{project?.previewMedia?.type === 'image' && (
								<Image
									className={`block w-full h-full object-cover`}
									src={urlForImage(project?.previewMedia?.image).url()}
									width={project?.previewMedia?.image?.asset?.metadata?.dimensions?.width}
									height={project?.previewMedia?.image?.asset?.metadata?.dimensions?.height}
									sizes="(min-width: 1112px) 33vw, (min-width: 712px) 50vw, 100vw"
									alt={project?.previewMedia?.image?.alt || ''}
									placeholder="blur"
									blurDataURL={project?.previewMedia?.image?.asset?.metadata?.lqip}
									unoptimized={project?.previewMedia?.image?.asset?.url?.includes(".gif") ? true : false} // mark Gif images as unoptimized (Next.js does not support Gif optimisation yet)
								/>
							)}

							{project?.previewMedia?.type === 'video' && project?.previewMedia?.video?.asset?.playbackId && (
								// <video
								// 	className={`block w-full h-full object-cover`}
								// 	src={`https://stream.mux.com/${project?.previewMedia?.video?.asset?.playbackId}/high.mp4`}
								// 	poster={project?.previewMedia?.video?.asset?.posterTime ? `https://image.mux.com/${project?.previewMedia?.video?.asset?.playbackId}/thumbnail.webp?time=${project?.previewMedia?.video?.asset?.posterTime}` : `https://image.mux.com/${project?.previewMedia?.video?.asset?.playbackId}/thumbnail.webp`}
								// 	playsInline
								// 	autoPlay
								// 	muted
								// 	loop
								// />
								<VideoPlayer
									playbackId={project?.previewMedia?.video?.asset?.playbackId}
									className={`block w-full h-full object-cover`}
									autoplay={true}
									loop
									showAudioToggle={false}
								/>
							)}
						</div>
						<div className="excerpt mt-4 relative">
							<p className={`style-body md:style-body--lg mb-1`}>{project?.title}</p>
							<p className={`style-body md:style-body--lg italic text-black`}>{project?.headline}</p>
						</div>
					</Link>
				))}
			</div>
		</div>
	)
}